import { authFetch } from '@/lib/auth-fetch';
import { getApiUrl } from '@/lib/api-config';

interface IntercomUserSignatureResponse {
  userHash: string;
}

export const intercomService = {
  async fetchUserSignature(): Promise<string> {
    const apiUrl = getApiUrl();
    const response = await authFetch(`${apiUrl}/api/intercom/user-signature`);

    if (!response.ok) {
      throw new Error(`Failed to fetch Intercom user signature: ${response.status}`);
    }

    const data: IntercomUserSignatureResponse = await response.json();
    return data.userHash;
  },
};
